import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Trophy, Users, Star } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroSection = () => {
  const scrollToStory = () => {
    const element = document.getElementById('story');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen relative flex items-center justify-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, hsl(48 100% 50% / 0.15) 0%, transparent 50%),
                           radial-gradient(circle at 75% 75%, hsl(48 100% 50% / 0.1) 0%, transparent 50%)`
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center pt-40 sm:pt-44">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_fc9d91ec-20e9-46cd-af6f-ead15b7d04e2/artifacts/aklhfw0k_SCC%20LOGO.jpeg" 
            alt="SCC Logo" 
            className="h-32 w-32 mx-auto object-contain mb-6"
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold mb-6"
        >
          <span className="text-gradient-gold">SCC Football Academy</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="font-body text-base sm:text-lg text-primary/80 max-w-3xl mx-auto mb-12"
        >
          SCC Football Academy is positioned as a <span className="text-primary font-semibold">competitive and sustainable</span> choice for youth football development in Singapore.
        </motion.p>

        {/* Key Stats */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16"
        >
          <div className="glass-card gold-border rounded-xl p-6">
            <Trophy className="h-10 w-10 text-primary mx-auto mb-3" />
            <h3 className="font-display text-2xl text-primary font-bold">Est. 1852</h3>
            <p className="text-muted-foreground text-sm">Singapore Cricket Club</p>
          </div>
          <div className="glass-card gold-border rounded-xl p-6">
            <Users className="h-10 w-10 text-primary mx-auto mb-3" />
            <h3 className="font-display text-2xl text-primary font-bold">234+</h3>
            <p className="text-muted-foreground text-sm">Football Section Members</p>
          </div>
          <div className="glass-card gold-border rounded-xl p-6">
            <Star className="h-10 w-10 text-primary mx-auto mb-3" />
            <h3 className="font-display text-2xl text-primary font-bold">SFL Div 1</h3>
            <p className="text-muted-foreground text-sm">Current Champions</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <Button
            onClick={scrollToStory}
            variant="outline"
            className="gold-border hover:bg-primary/10 text-primary group"
          >
            Explore Our Story
            <ArrowDown className="ml-2 h-4 w-4 group-hover:translate-y-1 transition-transform" />
          </Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="flex flex-col items-center"
        >
          <span className="text-muted-foreground text-xs mb-2">Scroll to explore</span>
          <ArrowDown className="h-5 w-5 text-primary" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
